// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

// ⚠️ REPLACE THE PLACEHOLDERS BELOW WITH YOUR ACTUAL FIREBASE CONFIG ⚠️
const firebaseConfig = {
  apiKey: "AIzaSyAFLnhlHjhFSfaqoL400MNcN-Qe_Tc7IBU",
  authDomain: "mapmytrip-10081.firebaseapp.com",
  projectId: "mapmytrip-10081",
  storageBucket: "mapmytrip-10081.appspot.com",
  messagingSenderId: "406108520891",
  appId: "1:406108520891:web:da465b843813a4befb449e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth service and provider
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// Recommended fix for prompt issue (forces account selection)
provider.setCustomParameters({ 
    prompt: "select_account" 
});

// Export the Google Sign-In function
export const signInWithGoogle = () => signInWithPopup(auth, provider);

// Optional: Add a logout function
export const signOutUser = () => auth.signOut();